import { updateState } from '@fil-global/eiswagen';
import get from 'lodash/get';

import {
  CLOSE_CONCURRENT_REMINDER,
  INACTIVE_RENEW,
  INACTIVE_SHOW_MODAL,
  INIT_STATE,
  LOGOUT_FAILURE,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  SESSION_VALIDATE_FAILURE,
  SESSION_VALIDATE_REQUEST,
  SESSION_VALIDATE_SUCCESS,
  SET_TOKEN,
  USER_AUTHENTICATED,
  USER_LOGGEDOUT,
} from './constants';

export const initialState = {
  isAuthenticated: false,
  sessionCheckDone: false,
  currentUserData: null,
  error: null,
  token: null,
  inactiveTiming: 0,
  inactiveModalShown: false,
  concurrentStatus: null,
  loggedOut: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case INIT_STATE:
      return updateState(state, {
        error: null,
        loggedOut: false,
      });
    case SESSION_VALIDATE_REQUEST:
      return state;
    case SESSION_VALIDATE_SUCCESS:
      return updateState(state, { sessionCheckDone: true, isAuthenticated: true });
    case SESSION_VALIDATE_FAILURE:
      return updateState(state, { sessionCheckDone: true, isAuthenticated: false });
    case LOGOUT_REQUEST:
      return updateState(state, { error: get(action, 'data.error', null), loggedOut: true });
    case LOGOUT_SUCCESS:
    case LOGOUT_FAILURE:
      return state;
    case USER_AUTHENTICATED:
      return updateState(state, {
        isAuthenticated: true,
        currentUserData: action.data,
        concurrentStatus: action.data ? action.data.concurrentStatus : false,
        loggedOut: false,
      });
    case USER_LOGGEDOUT:
      return updateState(state, {
        isAuthenticated: false,
        currentUserData: null,
        error: action.data || state.error,
        inactiveModalShown: false,
      });
    case SET_TOKEN:
      return updateState(state, {
        token: action.data || null,
      });
    case INACTIVE_RENEW:
      return updateState(state, {
        inactiveTiming: action.data,
        inactiveModalShown: false,
      });
    case INACTIVE_SHOW_MODAL:
      return updateState(state, {
        inactiveModalShown: !!action.data,
      });
    case CLOSE_CONCURRENT_REMINDER:
      return updateState(state, {
        concurrentStatus: false,
      });
    default:
      return state;
  }
};
